// extracted by mini-css-extract-plugin
module.exports = {"container":"layout_container__B_Rgx","page":"layout_page__ZBVCx","content":"layout_content__M_5eu","footer":"layout_footer__U7ng8"};